import { render } from "./RocksBanner.vue?vue&type=template&id=d583f26c"
import script from "./RocksBanner.vue?vue&type=script&lang=js"
export * from "./RocksBanner.vue?vue&type=script&lang=js"

import "./RocksBanner.vue?vue&type=style&index=0&id=d583f26c&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\compro.rimba.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__